import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { XYFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'
import { scaleTime } from 'd3-scale'

import { Grid, Typography } from 'material-ui'

const styles = theme => ({
  tooltipContent: {
    background: 'rgb(0, 0, 0, 0)',
    border: 1,
    color: 'grey',
    padding: 2,
    fontSize: 14
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  headline: {
    color: 'pink'
  },
  headlineAsset: {
    color: 'lightgreen'
  },
  display1: {
    color: 'lightgrey',
    textAlign: 'left',
    padding: '30px'
  }
})

@withStyles(styles)
export default class FinaChartAccount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateSeleted: new Date(moment())
        .toISOString('yyyy-MM-dd')
        .substring(0, 10),
      weekNo: '22'
    }
  }

  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    //Code from https://techbrij.com
    var result = {},
      ret = []
    var newCols = []
    for (var i = 0; i < dataArray.length; i++) {
      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {}
      }
      if (dataIndex === '') {
        result[dataArray[i][rowIndex]][dataArray[i][colIndex]] = dataArray[i]
      } else {
        result[dataArray[i][rowIndex]][dataArray[i][colIndex]] =
          dataArray[i][dataIndex]
      }

      //To get column names
      if (newCols.indexOf(dataArray[i][colIndex]) === -1) {
        newCols.push(dataArray[i][colIndex])
      }
    }

    newCols.sort(function(a, b) {
      return new Date(a) - new Date(b)
    })
    var item = []

    //Add Header Row
    item.push('Item')
    item.push.apply(item, newCols)
    ret.push(item)

    //Add content
    for (var key in result) {
      item = []
      item.push(key)
      for (i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || '-')
      }
      ret.push(item)
    }
    return ret
  }

  render() {
    const { classes } = this.props
    const data = this.props.chart
      ? JSON.parse(this.props.chart.dataSetNew.dataPoints)
      : JSON.parse(this.props.data)

    var dataByAccounts = this.getPivotArray(data, 'Account', 'Date', '')
    dataByAccounts.shift()

    var dataByAccountsMaxDate = []

    dataByAccounts.map((acc, index) => {
      acc.shift()
      let maxDates = acc.map(d => moment(new Date(d.Date)))
      var maxAccDate = moment.max(maxDates)
      const dataAccountMax = acc.filter(
        a =>
          moment(new Date(a.Date)).format('Y/M/D') ===
          maxAccDate.format('Y/M/D')
      )
      dataByAccountsMaxDate.push(dataAccountMax)
      return dataByAccountsMaxDate
    })

    return (
      <div>
        <div style={{ height: this.props.height }}>
          <Grid container spacing={16}>
            {dataByAccounts.map((acc, index) => (
              <Grid item xs={6} key={`acc-grid-${index}`}>
                {dataByAccountsMaxDate.map(
                  (m, index) =>
                    m[0].Account === acc[0].Account ? (
                      <div key={`acc-${index}`}>
                        <Typography
                          key={`acc-amount-${index}`}
                          variant="headline"
                          className={
                            m[0].Type === 'Asset'
                              ? classes.headlineAsset
                              : classes.headline
                          }
                        >
                          {m[0].Amount}
                        </Typography>
                        <Typography variant="caption" key={`acc-name-${index}`}>
                          {m[0].Account}
                        </Typography>
                      </div>
                    ) : (
                      ''
                    )
                )}
                <div
                  key={acc[0].Account}
                  style={{ width: '100%', textAlign: 'center', margin: 'auto' }}
                >
                  <XYFrame
                    size={[this.props.width / 2, this.props.height / 5]}
                    margin={{
                      left: this.props.width / 10.5,
                      top: this.props.height / 24,
                      right: this.props.width / 12.6,
                      bottom: this.props.height / 9.6
                    }}
                    xScaleType={scaleTime()}
                    xAccessor={d => new Date(d.Date)}
                    yAccessor={d => d.Amount}
                    lines={[{ label: '$', coordinates: acc }]}
                    lineStyle={d =>
                      d.coordinates[0].Type === 'Asset'
                        ? { stroke: 'lightgrey' }
                        : { stroke: 'lightgrey' }
                    }
                    hoverAnnotation={true}
                    tooltipContent={d => (
                      <div className={classes.tooltipContent}>
                        <p>
                          {moment(new Date(d.Date)).format('M/D')}
                          <br />
                          {parseFloat(d.Amount).toFixed(0)}
                        </p>
                      </div>
                    )}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/FinaChartAccount.js